export const CAR_NPS = 'Car NPS';
export const COMP_CLASSIC = 'Car Classic';
export const CAR = 'CAR';
export const NON_PRODUCT_SPECIFIC = 'Non Product Specific';
